<template lang="pug">
  div(id='outerDiv' ref='outerDiv')  
    div(id='spacerDiv' :class="{ displayed: aptSearchSticky }")
    div(id='aptSearchFormDiv' 
        :class="{ displayed: aptSearchDisplayed, sticky: aptSearchSticky }"
        ref='aptSearchFormDiv'
    )
      h2 Apartment Search
      //el-menu( :collapse="collapseNav" class="searchNavSidebar")
      ApartmentSearchForm
      el-button(
        type='primary' 
        plain
        @click='resetSearch' 
        icon="el-icon-refresh"
      ) Reset
      el-button(
        type='primary' 
        @click='search(true)' 
        v-bind:loading='loading'
        icon="el-icon-search"
      ) Search
      //h2( id='quick-search__header' ) Quick Search
      //span( @click='quickSearch("")' ) Allston 1
    div(id='apartment-browser__container')
      div(v-if='listings == null || listings.length == 0')
        el-alert( type='warning' v-if='listings && listings.length == 0' effect="dark" :closable="false" show-icon center) We didn't find any listings matching your request.  Consider broadening your search!
        p( class='el-icon-search' )  The results for your search will appear here.
        p( class='el-icon-star-on' )  Add listings to your favorites to keep track of ones you like!
        p( class='primary-light') Much of this information is collected from property managers and other third parties. While we try to keep the information on this site as up to date as possible, the rentals market moves extremely quickly and some listings may be no longer available.  For the most current information or to schedule viewings, 
          router-link(to="/contact") contact us!
      div(id='loading-film-div' :class="{ active: loading }" )
        img( src='../assets/loading.png' )
      el-pagination( 
        v-if="listingsCount > listingsPerPage" 
        layout="total, prev, pager, next, slot"
        v-bind:page-size.sync="listingsPerPage"
        v-bind:total="listingsCount"
        v-bind:current-page.sync="listingsPageIndex"
        @current-change="search"
        background
        :pager-count="5"
      )
        el-dropdown( type="primary" trigger="click" @command='sortListingsBy')
          span( class='el-dropdown-link' ) Sort...
          el-dropdown-menu( slot='dropdown' )
            el-dropdown-item( command="updated" ) Recently Updated
            el-dropdown-item( command="city" ) City
            el-dropdown-item( command="date" ) Date
            el-dropdown-item( command="rent_asc" ) Rent, lower first
            el-dropdown-item( command="rent_desc" ) Rent, higher first
      ListingBrowser( :listings='listings' @apt_unit_activated="listingSet => $emit('update:active-listing', listingSet)" hideSpinner='true' )
      div( id ="search-expand__container" )
        el-button( 
          id='searchExpandButton' 
          type='primary' 
          @click='aptSearchDisplayed = !aptSearchDisplayed' 
          icon="el-icon-search" 
        )
</template>

<script>
import ApartmentSearchForm from './ApartmentSearchForm.vue'
import ListingBrowser from './ListingBrowser.vue'
import { mapState } from 'vuex'
import { searchRentals, requestWasCancelled } from '../api/listings'

export default {
  components: {
    ApartmentSearchForm,
    ListingBrowser
  },
  metaInfo: {
    title: 'Apartment Search, Boston and Beyond | Upright Realty',
    meta: [
      { name: 'description', content: 'Search our database of the finest Boston apartments to see what might fit your style and budget, then contact us!' }
    ]
  },
  data(){
    return{
      loading: false,
      listings: null,
      listingsCount: 0,
      listingsPageIndex: 1,
      listingsPerPage: 20,
      listingsSort: {direction:"asc", name: "updateDate"},
      searchCancelFunction: null,
      aptSearchDisplayed: true,
      aptSearchSticky: false,
      cancelToken: {}
    }
  },
  computed: {
    ...mapState(["beds", "baths", "availFrom", "availTo", "minRent", "maxRent", "pets", "noFee", "locations", "photosOnly", "streetName", "listingIDs"])
  },
  methods: {
    formatDate(date){
        return (date.getMonth() + 1) + '/' + date.getDate() + '/' +  date.getFullYear()
    },
    search(reset, groupID, background){
      if (reset==true) this.listingsPageIndex = 1;
      if (this.cancelToken.cancel) this.cancelToken.cancel();
      if (!background) this.loading = true;
      searchRentals({
        beds: this.beds,
        baths: this.baths,
        availFrom: this.availFrom,
        availTo: this.availTo,
        minRent: this.minRent,
        maxRent: this.maxRent,
        pets: this.pets,
        noFeeOnly: this.noFee,
        photosOnly: this.photosOnly,
        locations: this.locations,
        streetName: this.streetName,
        listingIDs: this.listingIDs,
        sortName: this.listingsSort.name,
        sortDirection: this.listingsSort.direction,
        groupID: groupID,

        listingsPerPage: this.listingsPerPage,
        pageNumber: this.listingsPageIndex,

        cancelToken: this.cancelToken
      })
      .then(({listings, totalNumber}) => {
        this.listings = listings ? listings : [];
        this.listingsCount = totalNumber;
        this.loading = false;
        if (!background) this.aptSearchDisplayed = false;
      })
      .catch(error => {
        if (!requestWasCancelled(error)) {
          this.loading = false;
          alert("Unable to access apartment listings at this time, please try again later! " + error);
        }
      })
    },
    sortListingsBy(sort){
      var sortOptions = {
        city: {direction:"asc", name: "city"},
        date: {direction:"asc", name: "availDate"},
        rent_asc: {direction:"asc", name: "rent"},
        rent_desc: {direction:"desc", name: "rent"},
        updated: {direction:"asc", name: "updateDate"}
      }
      this.listingsSort = sortOptions[sort] ? sortOptions[sort] : sortOptions['city'];
      this.listingsPageIndex = 1;
      this.search();
    },
    resetSearch(){
      this.$store.commit('resetSearchParameters');
    }
  },
  mounted() {
    //if (this.$route.params.group){
      //this.resetSearch();
    //  this.search(true, this.$route.params.group);
      //alert(this.$route.params.group)
    //}
    this.$route.params.group ? this.search(true, this.$route.params.group, true) : this.search(true, null, true);
    //window.onscroll = () => {
      //this.aptSearchSticky = (window.pageYOffset > this.$refs.outerDiv.offsetTop - 71);
    //}
  }
}
</script>

<style lang="scss" scoped>
//@import '../_variables';

/* 
::-webkit-scrollbar {
  width: 20px;
}

::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey; 
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background: red; 
  border-radius: 10px;
}
*/

#apartment-browser__container .primary-light{
  color: mix(white, $color-primary, 50);
}

#aptSearchFormDiv{
  position: sticky;
  position: -webkit-sticky;
  text-align: right;
  top: 0;
  margin-bottom: auto;

}

#spacerDiv{
  width: 320px;
  flex-shrink: 0;
  display: none;
}
#spacerDiv.displayed{
  display: block;
  /* Make sure to override for smaller screen */
}

#apartment-browser__container{
  width: 100%;
}

.searchNavSidebar{
  overflow: hidden;
  z-index: 100;
  flex-shrink: 0;
}

/* I don't think I'm using this, check*/
.searchNavSidebar.el-menu--collapse{
  width: 0px;
}


#outerDiv{
  display: flex;
  margin-top: 5px;
  // width: 99%;
  //overflow: hidden;
  overflow: visible;
}


@media screen and (max-width: 720px) {
  #aptSearchFormDiv{
    position: fixed;
    background-color: $color-background;
    z-index: 2;
    padding: 5px;
    transition: all .3s ease-in-out;
    box-shadow: 2px 2px 4px gray;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    min-height: 450px;
    height: 100%;
    top: 50%;
    transform: translate(-100%, -50%);
  }
  #aptSearchFormDiv.displayed{
    transform: translate(0, -50%);
  }
  #aptSearchFormDiv h2{
    border-radius: 5px;
    margin: 0;
  }
  #searchExpandButton.el-button{
    display: block;
  }
  #spacerDiv.displayed{
    display: none;
  }
  #aptSearchFormDiv #quick-search__header{
    margin-top: 15px;
  }
}

#search-expand__container{
  position: fixed;
  bottom: 0;
  width: 100%;
  padding: 5px;
  text-align: left;
  z-index: 5;
}

#searchExpandButton{
  display: none;
  box-shadow: 4px 4px 4px black;
}

.el-dropdown-link {
  cursor: pointer;
  color: mix(white, $color-primary, 30);
}

#loading-film-div{
  position: absolute;
  display: none;
  width: 100%;
  height: 100%;
  z-index: 9999;
  opacity: 1;
}
#loading-film-div.active{
  display: block;
}
#loading-film-div img{
  width: 100px;
  height: 100px;
  position: fixed;
  top: 40%;
  left: 50%;
}
#loading-film-div.active img{
  animation: rotate 1.5s linear infinite;
  @keyframes rotate {
    to {
      transform: rotate(360deg);
    }
  }
  filter: opacity(.3) drop-shadow(0 0 0 $color-accent);
}

.el-pagination{
  position: sticky;
  top: 0;
  background-color: $color-background;
  z-index: 1;
  width: 95%;
  overflow:hidden;
}

#quick-search__header{
  margin-top: 15px;
}

a{
  //color: mix(black, $color-primary, 30);
  color: $color-accent;
  text-decoration: underline;
}

#apartment-browser__container p{
  display: block;
  font-size: 1.2em;
  color: mix(white, $color-primary, 10);
  
}

#apartment-browser__container p:last-of-type{
  font-size: .9em;
  //align-self: flex-end;
}

</style>
